import { AnyAction, Reducer } from "redux";
import { SET_FORM_MODAL_OPEN, SET_FORM_MODAL_ERROR } from "./constants";

interface INotificationReducer {
    formModalOpen: boolean,
    formFeedModalOpen: boolean,
    error: string | null
}

const initialState = {
    formModalOpen: false,
    formFeedModalOpen: false,
    error: null
}

const forms: Reducer<INotificationReducer, AnyAction> = (state = initialState, action): INotificationReducer => {
    switch (action.type) {

        case SET_FORM_MODAL_OPEN: {
            return {
                ...state,
                formModalOpen: action.payload
            }
        }

        case SET_FORM_MODAL_ERROR: {
            return {
                ...state,
                error: action.payload
            }
        }

        case "SET_FORM_MODAL_FEED_OPEN": {
            return {
                ...state,
                formFeedModalOpen: action.payload
            }
        }

        default: return state;
    }
}

export default forms;